import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IconButton, Box, Badge, Menu, MenuItem, Typography, Chip } from '@mui/material';
import { Badge as BadgeAntd } from 'antd';
import Scrollbar from '@components/custom-scroll/Scrollbar';

import { Stack } from '@mui/system';

import { onCountNotification, onGetNotificationClient } from '@store/notification/actions';
import { getListNotification, getCountNotification } from '@store/notification/selector';
import { getUserData } from '@store/user/selector';
import { BellRingingIco } from '@src/Modules/Public/assets/svg';

const eventId = localStorage.getItem('eventId');

const Notifications = ({ style, styleIcon }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useSelector(getUserData);
  const listNotification = useSelector(getListNotification);
  const count = useSelector(getCountNotification);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (!!userData?.eventId || !!eventId) {
      onInitData();
    }
  }, [JSON.stringify(userData)]);

  const onInitData = async () => {
    dispatch(onGetNotificationClient({ eventId: userData?.eventId ?? eventId }));
    dispatch(onCountNotification(userData?.eventId ?? eventId));
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  return (
    <Box>
      <IconButton
        size="medium"
        aria-label="show 11 new notifications"
        color="inherit"
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          ...(anchorEl2 && {
            color: 'primary.main',
          }),
        }}
        style={styleIcon}
        onClick={handleClick2}
      >
        {count > 0 ? (
          <Badge variant="dot" color="primary">
            <BellRingingIco style={style} />
          </Badge>
        ) : (
          <BellRingingIco style={style} />
        )}
      </IconButton>
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{
          '& .MuiMenu-paper': {
            width: '360px',
          },
        }}
      >
        <Stack direction="row" py={2} px={4} justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('CORE:notification')}</Typography>
          {count && (
            <Chip
              label={t('CORE:count_notification', { count: count })}
              color="primary"
              size="small"
            />
          )}
        </Stack>
        <Scrollbar sx={{ height: '385px' }}>
          {listNotification?.map((notification, index) => (
            <Box key={index}>
              <MenuItem
                sx={{ py: 2, px: 4 }}
                onClick={() => history.push(`/message/detail/${notification?.id}`)}
              >
                <Stack direction="row" spacing={2}>
                  <BadgeAntd color="blue" status="processing" />
                  <Box>
                    <Typography
                      variant="subtitle2"
                      color="textPrimary"
                      fontWeight={600}
                      noWrap
                      sx={{
                        width: '240px',
                      }}
                    >
                      {notification.title}
                    </Typography>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      sx={{
                        width: '240px',
                      }}
                      noWrap
                    >
                      {notification.name}
                    </Typography>
                  </Box>
                </Stack>
              </MenuItem>
            </Box>
          ))}
        </Scrollbar>
      </Menu>
    </Box>
  );
};

export default Notifications;
